import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
import cardBoxTitle from "./pi-card-box-title.vue";
let PiCardBox = class PiCardBox extends Vue {
};
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "title", void 0);
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "titleSize", void 0);
__decorate([
    Prop({ default: "left" })
], PiCardBox.prototype, "titleIconPos", void 0);
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "size", void 0);
__decorate([
    Prop({ default: "line" })
], PiCardBox.prototype, "titleIcon", void 0);
__decorate([
    Prop({ default: true })
], PiCardBox.prototype, "headerShow", void 0);
__decorate([
    Prop({ default: false })
], PiCardBox.prototype, "flex", void 0);
__decorate([
    Prop({ default: "" })
], PiCardBox.prototype, "type", void 0);
PiCardBox = __decorate([
    Component({
        components: {
            "pi-card-box-title": cardBoxTitle,
        },
    })
], PiCardBox);
export default PiCardBox;
